import { createContext, ReactNode, useContext } from "react";

import { ClientsPageAnalytics } from "../../types";

export type ClientPageAnalyticsContextProps = {
  analytics?: ClientsPageAnalytics;
};

const ClientPageAnalyticsContext = createContext<
  ClientsPageAnalytics | undefined
>(undefined);

export const ClientPageAnalyticsProvider = ({
  analytics,
  children,
}: ClientPageAnalyticsContextProps & { children: ReactNode }) => {
  return (
    <ClientPageAnalyticsContext.Provider value={analytics}>
      {children}
    </ClientPageAnalyticsContext.Provider>
  );
};

export const useClientPageAnalyticsContext = () => {
  const context = useContext(ClientPageAnalyticsContext);
  return context;
};
